// import { RootStoreContext } from "app/stores/rootStore";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Spinner, Container, Alert, Col } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";

const Loader = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["translation"], translationHookOptions);
  

  return (
    <Container className="mt-5 themed-container" fluid>
      <Col sm={12} lg={{ size: 4, offset: 4 }}>
        <Alert color={ theme ? theme.loaderColor : "grey"} className="text-center">
          <div className="mb-2">{t("loading")}</div>
          <Spinner color="light" />
        </Alert>
      </Col>
    </Container>
  );
};

export default Loader;
